function parseSignedAmount(raw) {
    const num = parseFloat(String(raw || '0').replace(/[^\d.-]/g, ''));
    return Number.isNaN(num) ? 0 : num;
}

export function parseBetSettleMessage(message) {
    if (!message || message.action !== 'BET_SETTLE') {
        return null;
    }

    const payload = message.data || {};
    const list = Array.isArray(payload.list) ? payload.list : [];
    const wins = list.filter((item) => {
        const result = item.win_lose || item.winLose || '';
        return String(result).toUpperCase() === 'WIN';
    });

    const totalPayout = wins.reduce((sum, item) => {
        const payoutRaw = item.payout_amount ?? item.payoutAmount;
        if (payoutRaw != null && payoutRaw !== '') {
            return sum + parseSignedAmount(payoutRaw);
        }
        return sum + parseSignedAmount(item.change_amount || item.changeAmount);
    }, 0);

    return {
        issue: payload.issue != null ? String(payload.issue) : '',
        balance: payload.balance,
        list,
        wins,
        winCount: wins.length,
        hasWin: wins.length > 0,
        profitText: totalPayout > 0 ? `+${totalPayout.toFixed(2)}` : '',
    };
}
